import React from 'react';
import { Link } from 'react-router-dom';
import { Alert, Button, Table } from 'reactstrap';
import { auth } from '../../Api';
import { formatServerMessage } from '../../utils/serverErrors';
import {
	signInText, canChangePassword, openChangePassword, NO_DISTRICT_MANAGERS, DISTRICT_MANAGERS_NOTE
} from '../../utils/loginAccounts';

// The Account page's Login Accounts tab (Company accounts only; laravel LoginAccountsController): the account's one
// admin (email, last sign-in, Change password: the header's own form) and its district managers, who are not admins
// (name, district, email, last sign-in, a link to their page). A company admin sees their own account (the server
// decides); the super admin the account chosen in the admin website (localStorage companyId). District managers never
// see the Account page.
class LoginAccountsTab extends React.Component {
	constructor(props) {
		super(props);
		this.state = { loading: true, error: '', data: null };
	}

	componentDidMount() {
		const level = this.storage('admin_level');
		const request = {};
		if (level === 'a') {
			request.company_id = this.storage('companyId');
		}
		auth.getLoginAccounts(request)
			.then((res) => {
				if (res.data.code == 200) {
					this.setState({ loading: false, data: res.data });
				} else {
					this.setState({ loading: false, error: formatServerMessage(res.data.message, 'The login accounts could not be loaded.') });
				}
			})
			.catch(() => this.setState({ loading: false, error: 'The login accounts could not be loaded. Please try again.' }));
	}

	storage(key) {
		try {
			return localStorage.getItem(key);
		} catch (e) {
			return null;
		}
	}

	render() {
		const { loading, error, data } = this.state;
		if (loading) {
			return <p className="mt-3">Loading login accounts...</p>;
		}
		const ownAdmin = canChangePassword(this.storage('admin_level'), this.storage('main_admin_level'));
		return (
			<div className="mt-3">
				{error && <Alert color="danger">{error}</Alert>}
				{data && (
					<React.Fragment>
						<h5 className="mb-1">Account admin</h5>
						<p className="text-muted small mb-2">The one login that runs this account.</p>
						<div className="table-responsive">
							<Table size="sm" className="mb-1">
								<thead>
									<tr><th>Email</th><th>Last sign-in</th><th></th></tr>
								</thead>
								<tbody>
									<tr>
										<td>{data.admin.email}</td>
										<td className="text-nowrap">{signInText(data.admin.last_sign_in_at)}</td>
										<td className="text-right">
											{ownAdmin
												? <Button color="primary" size="sm" onClick={openChangePassword}>Change password</Button>
												: <span className="text-muted small">Only the account admin can change this password.</span>}
										</td>
									</tr>
								</tbody>
							</Table>
						</div>

						<h5 className="mt-4 mb-1">District managers</h5>
						{data.district_managers.length === 0 && <p className="mb-1">{NO_DISTRICT_MANAGERS}</p>}
						{data.district_managers.length > 0 && (
							<div className="table-responsive">
								<Table size="sm" className="mb-1">
									<thead>
										<tr><th>Name</th><th>District</th><th>Email</th><th>Last sign-in</th></tr>
									</thead>
									<tbody>
										{data.district_managers.map((manager) => (
											<tr key={manager.id}>
												<td><Link to={'/district-manager-info/' + manager.id}>{manager.name || 'District manager ' + manager.id}</Link></td>
												<td>{manager.district || 'No district yet'}</td>
												<td>{manager.email}</td>
												<td className="text-nowrap">{signInText(manager.last_sign_in_at)}</td>
											</tr>
										))}
									</tbody>
								</Table>
							</div>
						)}
						<p className="text-muted small">{DISTRICT_MANAGERS_NOTE}</p>
					</React.Fragment>
				)}
			</div>
		);
	}
}

export default LoginAccountsTab;
